import type { WorkflowOperationMessage } from 'flow/store/engine/types';
import { WorkflowOperationType } from '../../store/engine/constants';

export const workflowOperationMessagesByType = {
  UPDATED_ALL_BOOL_OPERATORS_SAME_LEVEL: 'All operators on the same level must be the same. If you want to change the operator, create a group.',
  AUTO_CORRECTED_AMBIGUOUS_OPERATOR_RULE: 'The rule has been auto-corrected with the operator you selected.',
  UNDO_PERFORMED: 'You reverted the last change by undoing it.',
  AMBIGUOUS_RULE_FOUND: 'This rule contains ambiguous logic. Before editing, please take an action to correct it.',
  CANCEL_PENDING_RULE_GROUP: 'Click a closing parenthesis to close your group.',
};

export type AssistanceButtonAction = {
  name: string;
  id: string;
  value?: string;
};

export const getActionsForAssistance = (
  message: WorkflowOperationMessage['message'],
) => {
  let actions: AssistanceButtonAction[] = [];
  switch (message) {
    case WorkflowOperationType.AMBIGUOUS_RULE_FOUND:
      actions = [
        {
          name: 'Use AND',
          id: `${message}-action-use-and`,
          value: 'and',
        },
        {
          name: 'Use OR',
          id: `${message}-action-use-or`,
          value: 'or',
        },
      ];
      break;
    case WorkflowOperationType.CANCEL_PENDING_RULE_GROUP:
      actions = [{
        name: 'Cancel Grouping',
        id: 'cancel-group',
      }];
      break;
    // more to come...
  }

  return actions;
};

/**
 * Finds the last operation, optionally scoped to a specific publicId.
 * If no operation is found, returns undefined
 * if publicId is omitted, matches operations regardless of publicId
 * if messages are provided, return latest operation matching message
 * if types are provided, return the latest operation matching type
 */
export const findLastOperation = ({
  operations, publicId, messages, types,
}: {
  operations: WorkflowOperationMessage[];
  publicId?: WorkflowOperationMessage['publicId'];
  messages?: WorkflowOperationMessage['message'][];
  types?: WorkflowOperationMessage['type'][];
}) => operations.findLast(operation => {
  const messagesToMatch = messages ? new Set(messages) : null;
  const typesToMatch = types ? new Set(types) : null;

  return (publicId === undefined || operation.publicId === publicId) // optional: scope to an action
    && (!messagesToMatch || messagesToMatch.has(operation.message)) // optional
    && (!typesToMatch || typesToMatch.has(operation.type)); // optional
});
